<template>
    <div>

                        <div class="card  abtg__default-card abtg__orangeborder-bottom ">
                            <div class="card-head">
                                <header>Cerca corsista</header>
                            </div>
                            <div class="card-body ">
                                <form @submit.prevent="searchUser({searchText:searchText})">
                                    <div class="row">
                                        <div class="col">

                                            <div  >
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                                ><label class=" ">Email corsista</label>
                                                    <input class="mdl-textfield__input abtg__input" type="text"
                                                           v-model="searchText"
                                                    >
                                                </div>
                                                <button

                                                        class=" float-right btn btn-success  abtg__btn-third shadow-none abtg-button-big">
                                                    Cerca
                                                </button>

                                            </div>

                                        </div>
                                    </div>
                                </form>


                            </div>
                        </div>



                <div class="card  abtg__default-card abtg__orangeborder-bottom"
 >
                    <div class="card-head">
                        <header>Risultato</header>
                    </div>
                    <div class="card-body ">
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive">
                                    <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                                        <thead>
                                        <tr>
                                            <th class="mdl-data-table__cell--non-numeric text-left">
                                                Email
                                            </th>
                                            <th class="mdl-data-table__cell--non-numeric text-left">
                                                Iscritto dal
                                            </th>
                                            <th class="mdl-data-table__cell--non-numeric text-center">
                                                Accedi al suo account
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>


                                        <tr v-for="(u) in userList">
                                            <td>
                                                {{u.email}}
                                            </td>

                                            <td>
                                                {{u.created_at}}
                                            </td>


                                            <td class="text-center">
                                                <div class="text-center"><a href="#"
                                                                            @click="activeAssistance({id: u.id})"><i
                                                        class="fas fa-eye" style="font-size: 130%;"></i></a>
                                                </div>
                                            </td>
                                        </tr>


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>



    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';

    export default {
        data() {
            return {
                searchText: null,
            }
        },
        created() {

        },
        computed: {
            ...mapState('n_supercoach', ['userList', 'userInAssistance', 'formData'])
        },
        methods: {
            ...mapActions('n_supercoach', ['onSubmit',
                'searchUser', 'activeAssistance', 'realTimeAssistance', 'removeAssistance']),
        }
    }
</script>
